import { useEffect } from "react";
import { Box, Typography } from "@mui/material";
import { useBreadcrumb } from "@accredo/fe-shared/contexts/BreadcrumbContext.jsx";
import NotificationsTable from "../components/tables/NotificationsTable.jsx";

export function NotificationsPage() {
  const { setBreadcrumbs } = useBreadcrumb();

  useEffect(() => {
    setBreadcrumbs([
      { name: "Home", path: "/home" },
      { name: "Benachrichtigungen", path: "/notifications" },
    ]);
  }, [setBreadcrumbs]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 3,
        pt: 0,
        pb: 6,
      }}
    >
      {/* Page Header */}
      <Box>
        <Typography variant="h1">Benachrichtigungen</Typography>
      </Box>

      {/* Notifications Table with integrated filter tabs */}
      <NotificationsTable
        variant="full"
        enablePagination={true}
        enableSorting={true}
        enableTopToolbar={true}
        enableBottomToolbar={true}
        enableHeader={true}
        showViewAllLink={false}
      />
    </Box>
  );
}
